import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EmailSuggestions = ({ email, onSelect }) => {
    const domains = [
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@live.com',
        '@yahoo.com',
        '@icloud.com'
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        },
        exit: {
            opacity: 0,
            transition: { staggerChildren: 0.05, staggerDirection: -1 }
        }
    };

    const itemVariants = {
        hidden: { 
            opacity: 0, 
            y: 10, 
            filter: 'blur(8px)',
            scale: 0.9
        },
        visible: { 
            opacity: 1, 
            y: 0, 
            filter: 'blur(0px)',
            scale: 1,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 24
            }
        },
        exit: { 
            opacity: 0, 
            scale: 0.9, 
            filter: 'blur(4px)',
            transition: { duration: 0.2 }
        }
    };

    return (
        <AnimatePresence>
            {!email || email.includes('@') ? null : (
                <motion.div
                    key="email-suggestions-container"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className="flex flex-wrap gap-2 mt-2 mb-4"
                >
                    {domains.map((domain) => (
                        <motion.button
                            key={domain}
                            variants={itemVariants}
                            type="button"
                            onClick={() => onSelect(email + domain)}
                            whileHover={{ 
                                scale: 1.05, 
                                backgroundColor: 'rgba(248, 72, 94, 0.1)',
                                borderColor: 'rgba(248, 72, 94, 0.4)'
                            }}
                            whileTap={{ scale: 0.95 }}
                            className="px-3 py-1.5 rounded-full border border-[#f8485e]/20 bg-white/40 backdrop-blur-sm text-[#f8485e] text-xs font-bold transition-colors shadow-sm whitespace-nowrap"
                        >
                            {domain}
                        </motion.button>
                    ))}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default EmailSuggestions;
